import PropTypes from 'prop-types';

export const basePropTypes = {
	helpLink: PropTypes.string,
	isError: PropTypes.bool,
	loading: PropTypes.bool,
	title: PropTypes.string.isRequired,
};
